module.exports = __webpack_public_path__ + "assets/left-arrow.d4da4c8b.svg";